
      import '@folkjs/labs/standalone/folk-space-attribute';
      import '@folkjs/labs/standalone/folk-shape-attribute';
      import { Gizmos } from '@folkjs/canvas/folk-gizmos';
      import { breathFirstTraverse } from '@folkjs/geometry/BoundingVolumeHierarchy';

      for (let i = 0; i < 100; i++) {
        const shape = document.createElement('div');

        shape.setAttribute(
          'folk-shape',
          `x: ${Math.random() * 750}; y: ${Math.random() * 750}; width: 45; height: 45;`,
        );

        document.body.append(shape);
      }

      function loop() {
        requestAnimationFrame(loop);
        const zoom = document.body.folkSpace.bvh;
        Gizmos.clear();

        breathFirstTraverse(document.body.folkSpace.bvh, (node) => {
          if (!node.isLeaf) {
            Gizmos.rect(node.aabb, { color: '#aca0a077' });
          }
        });
      }

      requestIdleCallback(() => loop());
    